export default {"src":"/_next/static/media/get-verified.ce995303.svg","height":120,"width":120,"blurWidth":0,"blurHeight":0};